package xim.poc.game.configuration.v0.behaviors

import xim.poc.game.ActorState
import xim.poc.game.CombatBonusAggregate

class MobCargoCrabBehavior(actorState: ActorState): V0MonsterController(actorState) {

    override fun applyMonsterBehaviorBonuses(aggregate: CombatBonusAggregate) {
        aggregate.mobSkillFastCast -= 30
        aggregate.fastCast -= 40
        aggregate.haste -= 10
        aggregate.spellInterruptDown += 80
    }

}